import {
	Directive,
	ElementRef,
	Input,
	OnChanges,
	Renderer2,
	SimpleChanges
} from "@angular/core";

@Directive({
	selector: "[appFileDragAndDropHover]",
	standalone: false
})
export class FileDragAndDropHoverDirective implements OnChanges {
	@Input()
	appFileDragAndDropHover = false;

	constructor(
		private renderer: Renderer2,
		private el: ElementRef
	) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.appFileDragAndDropHover.currentValue) {
			this.renderer.addClass(this.el.nativeElement, "file-upload-hover");
			return;
		}
		this.renderer.removeClass(this.el.nativeElement, "file-upload-hover");
	}
}
